import { EntityLinks, Goal, ID, IDPrefixes } from '@griply/types';

import { getLinkedIds } from '../links/get-linked-ids';
import { createPrefixId } from '../prefix-id';

// Required: a migrated goal records its parents nowhere else. No relationships → NO_ENTITY_LINKS.
export type GetGoalParentIdsOptions = {
  links: EntityLinks;
};

// Structural so callers holding a projection (colour resolution, tree rows, an update payload)
// can resolve parents too — both fields are read defensively below, so neither has to be present.
export type GoalParentSource = Pick<Goal, 'id'> &
  Partial<Pick<Goal, 'ancestorIds' | 'parentLinksMigrated'>>;

// Before migration the frozen chain is the only record of parents; its last entry is the direct one.
export const getGoalParentIds = (
  goal: GoalParentSource,
  { links }: GetGoalParentIdsOptions,
): ID[] => {
  if (goal.parentLinksMigrated) {
    return getLinkedIds(
      links,
      createPrefixId(goal.id, IDPrefixes.Goal),
      IDPrefixes.Goal,
    );
  }

  const ancestorIds = goal.ancestorIds ?? [];
  const directParentId = ancestorIds[ancestorIds.length - 1];

  return directParentId ? [directParentId] : [];
};
